import {
    Box,
    Button,
    CircularProgress,
    Container,
    Drawer,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';
import FileUploaderSingle from '../../components/upload/FileUploaderSingle';
import DropzoneWrapper from '../../styles/react-dropzone';

const AddDoc = (props) => {
  const { show, setShow, setReload } = props
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const defaultValues = {
    cat_id: '',
    lotno: '',
    name: ''
  }
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({ defaultValues });

  useEffect(() => {
    if(!show) {
      reset(defaultValues);
      setFiles([]);
    }
  }, [show])

  const onSubmit = async (data, e) => {
    setLoading(true);

    const [file] = files;

    const formData = new FormData()
    formData.append('ftype', data.ftype);
    formData.append('cat_id', data.cat_id);
    formData.append('lotno', data.lotno);
    formData.append('name', data.name);
    formData.append('file', file);

    try {
        await apiService.postFormData('/docs', formData)
        toast.success('등록 되었습니다.')
        setReload(reload => reload + 1)
    } catch (error) {
        console.error(error)
    } finally {
        setLoading(false)
        setShow(false)
    }
  }

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
    }
    setShow(open);
  };

  return (
    <Drawer anchor='right' open={show} onClose={toggleDrawer(false)}>
        <Container sx={{width: '800px', pt: 8, px: '2rem !important'}}>
            <form onSubmit={handleSubmit(onSubmit)} id="docform">
                <Box sx={{ mb: 9, textAlign: 'center' }}>
                <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                    문서 등록
                </Typography>
                </Box>

                <Grid container spacing={6}>

                    <Grid item xs={12}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">문서 유형</FormLabel>
                            <Controller
                                name="ftype"
                                control={control}
                                rules={{ required: true }}
                                defaultValue="1"
                                render={({ field }) => (
                                    <RadioGroup {...field} row>
                                        <FormControlLabel value="1" control={<Radio />} label="COA" />
                                        <FormControlLabel value="2" control={<Radio />} label="MSDS" />
                                    </RadioGroup>
                                )}
                            />
                            {errors.ftype && (
                                <FormHelperText sx={{ color: 'error.main' }} id='validation-async-ftype'>
                                    필수
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                        <Controller
                            name='cat_id'
                            control={control}
                            rules={{ required: true }}
                            defaultValue=""
                            render={({ field: { value, onChange } }) => (
                            <TextField
                                value={value}
                                label='상품번호'
                                id='cat_id'
                                onChange={onChange}
                                placeholder='카테고리 ID를 입력해주세요'
                                error={Boolean(errors.cat_id)}
                                aria-describedby='validation-async-cat_id'
                                variant="standard"
                            />
                            )}
                        />
                        {errors.cat_id && (
                            <FormHelperText sx={{ color: 'error.main' }} id='validation-async-cat_id'>
                            필수
                            </FormHelperText>
                        )}
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                        <Controller
                            name='lotno'
                            control={control}
                            rules={{ required: true }}
                            defaultValue=""
                            render={({ field: { value, onChange } }) => (
                            <TextField
                                value={value}
                                label='Lot No'
                                id='lotno'
                                onChange={onChange}
                                placeholder='Lot No를 입력해주세요'
                                error={Boolean(errors.lotno)}
                                aria-describedby='validation-async-lotno'
                                variant="standard"
                            />
                            )}
                        />
                        {errors.lotno && (
                            <FormHelperText sx={{ color: 'error.main' }} id='validation-async-lotno'>
                            필수
                            </FormHelperText>
                        )}
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <Controller
                                name='name'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='이름'
                                        id='name'
                                        onChange={onChange}
                                        placeholder='이름을 입력해주세요'
                                        error={Boolean(errors.sale_price)}
                                        aria-describedby='validation-async-name'
                                        variant="standard"
                                    />
                                )}
                            />
                            {errors.name && (
                                <FormHelperText sx={{ color: 'error.main' }} id='validation-async-name'>
                                    필수
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>        

                    <Grid item xs={12}>
                        <DropzoneWrapper>
                        <FileUploaderSingle files={files} setFiles={setFiles} />
                        </DropzoneWrapper>
                    </Grid>

                </Grid>
            </form>

            <Stack direction="row" spacing={2} sx={{ py: 16, justifyContent: 'center' }}>
                <Button type="submit" form="docform" variant='contained'>
                    {loading ? (
                    <CircularProgress
                        sx={{
                        color: 'common.white',
                        width: '20px !important',
                        height: '20px !important',
                        mr: theme => theme.spacing(2)
                        }}
                    />
                    ) : null}
                    등록
                </Button>
                <Button variant='outlined' color='secondary' onClick={() => setShow(false)}>
                    취소
                </Button>
            </Stack>
        </Container>
    </Drawer>
  )
}

export default AddDoc
